import React from "react";
import ObsIframe from "../../iframe-component/onboarding/ObsIframe";

const DataOverviewAndExport = () => {
  return <ObsIframe path="/export-data" />;
};

export default React.memo(DataOverviewAndExport);
